module.exports = __webpack_public_path__ + "media/images/category/feature/aoj_b/aoj_b-2-cf15a1ca7645c18c0be50bce707bedcb.jpg";